import { render } from "./PageHeader.vue?vue&type=template&id=269a39ac&ts=true"
import script from "./PageHeader.ts?vue&type=script&lang=ts"
export * from "./PageHeader.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__